export default function Services() {
  const services = [
    {
      title: 'Respite Care',
      description: 'Take time to recharge while we look after your loved one\'s health.',
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/f3f80fd75dec4892fd305e849e02a53d.jpeg',
    },
    {
      title: 'Personal Care & Hygiene',
      description: 'We help with bathing, oral hygiene, dressing, personal & toiletry services.',
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/e68b27bea7f4bdf3ea234f1456b1771b.jpeg',
    },
    {
      title: 'Light Housekeeping',
      description: 'Our housekeeping ensures your home stays clean and well organized.',
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/7eae088bc9004a8c99f63c4a2d349e41.jpeg',
    },
    {
      title: 'Meal Preparation',
      description: 'Our caregivers create meal plans based on your dietary needs or preference.',
      image: 'https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/ad31b115927161066ba452ac72b8732f.jpeg',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-6 lg:sticky lg:top-32">
            <h2 className="text-5xl font-bold text-orange-500">Our Services</h2>
            <p className="text-gray-700 text-base leading-relaxed">
              At Kali Kare Homecare Agency, our client centered approach is designed according to your individual needs
              &amp; requirements. Allow our expert staff to work around the clock to ensure we deliver the best health care.
            </p>
            <a
              href="#services"
              className="inline-block bg-[#5C4F8A] text-white px-8 py-3 rounded-lg hover:bg-[#4A3D72] transition-all duration-300 text-sm font-medium whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
            >
              Services
            </a>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {services.map((service, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
              >
                <div className="relative h-48 w-full overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <div className="p-6 space-y-3">
                  <h4 className="text-lg font-bold text-gray-900">{service.title}</h4>
                  <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}